/**
 * Confirm before opening a tel: URL — mirrors iOS ConfirmablePhoneCallButton (#104).
 */

export interface ConfirmPhoneCallMessages {
  /** e.g. "Call {name}?" */
  message: (contactName: string) => string;
}

/**
 * Ask for confirmation, then navigate to tel: if accepted.
 * Uses window.confirm by default (injectable for tests).
 */
export function confirmPhoneCall(params: {
  phone: string;
  contactName: string;
  messages: ConfirmPhoneCallMessages;
  confirmFn?: (message: string) => boolean;
  dialFn?: (telHref: string) => void;
}): boolean {
  const phone = params.phone.trim();
  if (!phone) return false;
  const name = params.contactName.trim() || phone;
  const message = params.messages.message(name);
  const confirmFn = params.confirmFn ?? ((msg: string) => window.confirm(msg));
  const dialFn =
    params.dialFn ??
    ((telHref: string) => {
      window.location.href = telHref;
    });
  if (!confirmFn(message)) return false;
  dialFn(`tel:${phone}`);
  return true;
}
